/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Show_In_SplitInputs */

const en_tables_custom_properties_show_in_split = /** @type {(inputs: Tables_Custom_Properties_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Show In Split`)
};

const de_tables_custom_properties_show_in_split = /** @type {(inputs: Tables_Custom_Properties_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Split anzeigen`)
};

/**
* | output |
* | --- |
* | "Properties Show In Split" |
*
* @param {Tables_Custom_Properties_Show_In_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_show_in_split = /** @type {((inputs?: Tables_Custom_Properties_Show_In_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Show_In_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_show_in_split(inputs)
	return de_tables_custom_properties_show_in_split(inputs)
});